// @flow

import React, { Component } from "react";
import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import CheckboxHierarchyTree from "../../checkbox-hierarchy-tree";
import type { CheckboxWidget as CheckboxWidgetProps } from "react-jsonschema-form/lib/components/widgets/CheckboxWidget";

type Props = $Exact<{
  ...CheckboxWidgetProps,
  options: Object,
}>;

class CheckboxHierarchyTreeWidget extends Component<Props> {
  handleChange = (selected: Array<Object>): void => {
    if (!selected) return;

    this.props.onChange(selected);
  };

  get selected() {
    if (!this.props.value) {
      return [];
    }

    return this.props.value.map(i => i.id);
  }

  get excluded() {
    if (!this.props.value) {
      return [];
    }

    return this.props.value.reduce(
      (acc, current) => (current.excluded ? [...current.excluded] : current),
      [],
    );
  }

  render() {
    return (
      <React.Fragment>
        <CheckboxHierarchyTree
          searchable={!!this.props.options.searchable}
          searchPlaceholder={this.props.options.searchPlaceholder}
          tree={this.props.schema.tree}
          selected={this.selected}
          excluded={this.excluded}
          disabled={false}
          onChange={this.handleChange}
          expanded={[]}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default CheckboxHierarchyTreeWidget;
